import React, { Suspense } from 'react';
import { Route, Switch, HashRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';
import routes from '@/router';
import BeforeRoute from '@/router/BeforeRoute';
import { Spin } from 'antd';
import { isStudentRoute, querySearchParam } from '@/utils/basic';
import { LiveRoomStore } from '@/store';
import { cookie } from '@gaodun.com/gtools';

let defaultStore: LiveRoomStore | {};
const whiteList = ['startapp', 'download', 'visit'];

// 启动页及学生端非Chrome浏览器
if(whiteList.some(name => window.location.hash.includes(name))){
     defaultStore = {};
}else {
     defaultStore = new LiveRoomStore();
     const roomId = querySearchParam('roomId');
     cookie.setCookie('roomId', roomId || '');
}

const Loading = (
    <div className="loading-container">
        <Spin tip={`正在加载...`} indicator={<img src="https://res.gaodunwangxiao.com/tools/2025-12-06/05907794_page_init_loading.gif" />} size="large" />
    </div>
);

const route = (
    <Switch>
        {routes.map(item => {
            return item.isBeforeRoute ? <BeforeRoute {...item} key={item.path} /> : <Route {...item} key={item.path} />;
        })}
    </Switch>
);

const initLink = () => {
    const scriptUrl = `https://gd-file.gaodun.com/browser-modal/bundle.js?v=${Date.now()}`;
    const adapterView = document.getElementById('adapterView');
    if (!adapterView) {
        const scriptTag = document.createElement('script');
        scriptTag.src = scriptUrl;
        scriptTag.id = 'adapterView';
        document.body.appendChild(scriptTag);
        scriptTag.onload = () => {
            // @ts-ignore
            window.useCompatibilityModal();
        };
    }
};

export default function () {
    isStudentRoute() && initLink();
    return (
        <Provider store={defaultStore}>
            <HashRouter>
                <Suspense fallback={Loading}>{route}</Suspense>
            </HashRouter>
        </Provider>
    );
}
